import { MainButton } from "@eventr/common-storybook";
import { useParams } from "react-router-dom";
import { routes } from "routing";
import { useEditSectionContext } from "../../feat/editItinerary/editSectionProvider";
import { useGlobalRouter } from "../../feat/globalRouter/useGlobalRouter";
import i18n from "../../i18n/i18next";

interface IEditButton {
  id?: string;
  data: any;
  renderOptions: IEditButtonOptions;
}
interface IEditButtonOptions {
  pageId?: number;
}

export const EditButton = ({ id, data, renderOptions }: IEditButton) => {
  const { section } = useEditSectionContext();
  const { pushPath } = useGlobalRouter();

  const { itemId } = useParams<{
    itemId: string;
  }>();
  const path = () => {
    if (renderOptions.pageId) {
      return routes.edit.sectionItemPageItem.build({
        sectionId: section!.id,
        itemId: itemId!,
        pageId: renderOptions.pageId,
        subItemId: data._id,
      });
    } else {
      return routes.edit.sectionItem.build({ sectionId: section!.id, itemId: data._id });
    }
  };
  return (
    <MainButton
      id={id + "editButton"}
      icon="Edit"
      text={i18n.t("general.edit")}
      size="small"
      onClick={() => {
        pushPath(path());
      }}
    />
  );
};
